export default __webpack_public_path__ + "static/media/search-icon-grey.0fa78666.svg";